export default "__VITE_ASSET__VvfE8EwF__"